import React from "react";
import RoleAccess from "../../Components/RoleAccess";
import "../../Styles/pages/product.scss";
import "../../Styles/pages/products.scss";
import { FullWidthCardTemplate } from "../Products/ProductSummaryInsights";
import { useDateFormatter } from "../../Components/FormatDateTime";
import { getAudienceModifiedFromBatches, getAudienceStatusFromBatches } from "./audienceBatchProgress";

const getLegacyAudienceStatus = (audience, t) => {
    const successfulImport = audience.entryCount === audience.importedCount;
    const processingImport = audience.applyStarted && !audience.appliedOn;

    if (audience.appliedOn === null && !audience.applyStarted) {
        return { label: t("business_customers.not-processed").toUpperCase(), className: "not-tag" };
    }
    if (processingImport) {
        return { label: t("business_customers.in_progress").toUpperCase(), className: "processed-ongoing" };
    }
    if (successfulImport) {
        return { label: t("business_customers.successful").toUpperCase(), className: "processed-success" };
    }
    return { label: t("business_customers.completed-errors").toUpperCase(), className: "processed-errors" };
};

const getAudienceStatus = (audience, t, audienceBatches, applyingBatchNos) => {
    if (!audience) {
        return { label: "", className: "status-pending" };
    }

    const batchStatus = getAudienceStatusFromBatches(audienceBatches, applyingBatchNos);
    if (batchStatus) {
        return {
            label: t(batchStatus.labelKey).toUpperCase(),
            className: batchStatus.className,
        };
    }

    return getLegacyAudienceStatus(audience, t);
};

const AudienceDetailCards = ({
    t,
    audience,
    defMembership,
    sideMenu,
    audienceBatches = [],
    applyingBatchNos = [],
    candidateSegments = [],
    candidateTags = [],
    criteriaLoading = false,
    displayMemberCount,
}) => {
    const { formatDate } = useDateFormatter();

    const importedDate = audience?.importedOn ? formatDate(audience.importedOn) : "";
    const batchModified = getAudienceModifiedFromBatches(audienceBatches);
    const hasBeenModified = batchModified.hasBeenModified
        || !!(audience?.appliedOn || audience?.applyStarted);
    const modifiedDate = batchModified.modifiedDate
        ? formatDate(batchModified.modifiedDate)
        : audience?.appliedOn
            ? formatDate(audience.appliedOn)
            : audience?.applyStarted
                ? formatDate(audience.applyStarted)
                : "";
    const { label: statusLabel, className: statusClass } = getAudienceStatus(
        audience,
        t,
        audienceBatches,
        applyingBatchNos
    );

    const mainCardAudience = [
        {
            page: "audience-detail",
            t,
            defMembership,
            audienceDetState: { audience },
            importedDate,
            hasBeenModified,
            modifiedDate,
            statusLabel,
            statusClass,
            candidateSegments,
            candidateTags,
            criteriaLoading,
            displayMemberCount,
        },
    ];

    const visibleSideMenu = sideMenu.filter(({ show = true }) => show);

    return (
        <div>
            <div className="grid nested-grid audience-detail-layout">
                <div className="col-12 xl:col-9 pl-0 audience-detail-main">
                    <div className="grid">
                        <FullWidthCardTemplate summary={mainCardAudience} />
                    </div>
                </div>

                <div className="col-12 xl:col-3 audience-detail-sidebar">
                    <RoleAccess roles={["OWNER", "ADMIN"]}>
                        <div id="product-detail-side-menu" className="audience-detail-side-menu">
                            <div className="audience-quick-actions-grid">
                                <p className="action-titles">{t("plan.quick_action")}</p>
                                {visibleSideMenu.map(({ label, icon, onclick, loading = false, disable }, i) => (
                                    <div key={i}>
                                        <div className="side-menu-content">
                                            <span
                                                onClick={loading || disable ? undefined : onclick}
                                                id={disable ? "disable-share-action-button" : undefined}
                                            >
                                                <i className={`pi ${icon}`} />
                                                <span>{loading ? `${label}...` : label}</span>
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </RoleAccess>
                </div>
            </div>
        </div>
    );
};

export default AudienceDetailCards;
